export enum OrderStatus {
    CREATED,
    RECEIVED,
    RESPONDING,
    ACCEPTED,
    REJECTED
}